import { render } from "./EntityForm.vue?vue&type=template&id=5e526f2e&ts=true"
import script from "./EntityForm.ts?vue&type=script&lang=ts"
export * from "./EntityForm.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__